import ResourcePageHeader from "../../components/ResourcePage/ResourcePageHeader";
import ResourceTilesGrid from "../../components/ResourcePage/ResourceTileGrid";
import { useTaggedResourceTiles } from "../../components/ResourcePage/helpers/useTaggedResourceTiles";
import styles from "./TalkToAnExpert.module.css";

const TALK_TO_EXPERT_TAG_FILTERS = [
  "Pathway Mentors",
  "Talk to an Expert",
  "Mentoring Programs",
];

const SECTION_TITLES: Record<string, string> = {
  "Pathway Mentors": "Talk More with Pathway Mentors",
  "Talk to an Expert": "Talk to an Expert at CSUF",
  "Mentoring Programs": "Find Additional Mentoring Programs",
};

const TalkToAnExpert = () => {
  const taggedResourceTiles = useTaggedResourceTiles(
    TALK_TO_EXPERT_TAG_FILTERS,
  );

  return (
    <>
      <ResourcePageHeader
        title="Talk to an Expert"
        showTileCount={false}
        showSectionLinks={false}
        className={styles.talkToAnExpertHeader}
      />

      <div
        style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
        data-cy="talk-to-an-expert-resources"
      >
        {taggedResourceTiles.map((section) => (
          <section key={section.tagFilter} className="resource-page-group">
            <p className={styles.talkToAnExpertSectionTitle}>
              {SECTION_TITLES[section.tagFilter] ?? section.tagFilter}
            </p>

            <ResourceTilesGrid
              resourceTiles={section.data}
              bookmarkSource="TalkToAnExpertTile"
            />
          </section>
        ))}
      </div>
    </>
  );
};

export default TalkToAnExpert;
